import React from 'react';
function Save({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18.667 20.5H5.833A1.833 1.833 0 014 18.667V5.833A1.833 1.833 0 015.833 4h10.084L20.5 8.583v10.084a1.833 1.833 0 01-1.833 1.833z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.833 20.5v-7.333H7.667V20.5M7.667 4v4.583H15"
      />
    </svg>
  );
}

export default Save;
